import { APP_ROUTES } from "~/constants/appRoutes";
import type { QuizRoute } from "~/constants/quizRoutes";
import { stripCodeSegment } from "~/lib/flags/routeCodes";

/** Session cookie set on an Oestra landing page; read by the quiz redirect and the experiment audience. */
export const LP_VISITED_COOKIE = "ib-lp-visited";

export const LP_VISITED_COOKIE_VALUE = "1";

/** Where the Oestra quiz sends visitors who have not seen a landing page yet. */
export const OESTRA_QUIZ_LP_REDIRECT_URL = APP_ROUTES.TREATMENT_BIOIDENTICAL_HRT;

/** The href every Oestra quiz CTA is given. `useQuizLink` resolves it to the LP, the new quiz, the old quiz or the PQP, so it is not a plain link to the LP. */
export const OESTRA_QUIZ_ENTRY_HREF = OESTRA_QUIZ_LP_REDIRECT_URL;

export type QuizEntryHref = QuizRoute | typeof OESTRA_QUIZ_ENTRY_HREF;

/** Existing LPs only: the redirect target is left out because it is where first-time visitors are sent, not a page they already saw. */
export const OESTRA_LP_PATHS: ReadonlySet<string> = new Set([
    APP_ROUTES.TREATMENT_HRT,
    APP_ROUTES.TREATMENT_HRT_3,
    APP_ROUTES.TREATMENT_PERIMENOPAUSE,
    APP_ROUTES.TREATMENT_PERIMENOPAUSE_AD,
    APP_ROUTES.TREATMENT_MENOPAUSE,
    APP_ROUTES.TREATMENT_ENDOMETRIOSIS,
    APP_ROUTES.TREATMENT_PCOS,
    APP_ROUTES.TREATMENT_POSTPARTUM,
    APP_ROUTES.TREATMENT_TESTOSTERONE,
    APP_ROUTES.MENOPAUSE_AD,
    APP_ROUTES.OESTRA_REASONS,
    APP_ROUTES.PRODUCT_PAGE,
    APP_ROUTES.PERI_LABS,
    APP_ROUTES.MENOPAUSE_WEIGHT_GAIN,
    APP_ROUTES.COMPARE_MIDI_HEALTH,
    APP_ROUTES.COMPARE_HONE_HEALTH,
    APP_ROUTES.COMPARE_ALLOY_HEALTH,
    APP_ROUTES.COMPARE_WINONA_HEALTH,
]);

/** Whether a page path is an existing Oestra LP, with or without the `[code]` segment in front. `usePathname` is null outside a matched route, such as on the 404 page. */
export const isOestraLpPath = (pathname: string | null): boolean =>
    !!pathname && OESTRA_LP_PATHS.has(stripCodeSegment(pathname));
